import Box from '@mui/material/Box';

import { useSidebar } from '@src/context/hooks';

const StyleSheet = {
  root: ({ isCollapsed }) => ({
    display: 'grid',
    gridTemplateRows: '1fr 48px 48px',
    gridTemplateColumns: (t) => (isCollapsed ? t.layout.sidebar.minWidth : t.layout.sidebar.maxWidth),
    height: (t) => `calc(100vh - ${t.layout.header.height}px)`,
  }),
};

function SidebarContainer(props) {
  const { isCollapsed } = useSidebar();
  return <Box {...props} sx={StyleSheet.root({ isCollapsed })} />;
}

SidebarContainer.displayName = 'SidebarContainer';
export default SidebarContainer;
